<template>
  <v-container style="background-color: var(--v-background-base);" fluid>
    <v-row>
      <v-col cols="12">
        <Back class="my-8" v-if="!isLoading"/>
      </v-col>
    </v-row>
    <v-row class="pt-9 mt-8" v-if="!isLoading" className="px-3">
      <v-col className="pt-7 pb-0" cols="12">
        <h1 class="px-4" className="principal-color">Termo de Uso</h1>
      </v-col>
      <v-col>
        <div class="px-4" v-html="template"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Back from '@/components/covid/back-arrow/index'
import UserTermsByUserId from "@/services/security/UserTerms.js";
import {mapMutations} from "vuex";

export default {
  name: "miniMenuCovid",
  components: {
    Back,
  },
  data: () => ({
    isLoading: true,
    template: ''
  }),
  beforeCreate() {
    this._userTermsService = new UserTermsByUserId();
  },
  async created() {
    this.loading(true)
    await this._userTermsService.GetUserTermsByUserId(this.$auth.user().id)
        .then(response => {
          this.template = response.data.body
        }).catch(error => {
          this.template = '<p>Não foi possível carregar Termos de Uso.</p>'
        }).finally(() => {
          this.isLoading = false
          this.loading(false)
        })
  },
  methods: {
    ...mapMutations(["loading"])
  }
}
</script>

<style scoped>

/*background effect blur*/
.bg-glass-effect {
  background: var(--v-white) !important;
  height: 100vh;
}

.principal-color {
  color: var(--v-textLink);
}

</style>